import isGroupTableQuery from './isGroupTableQuery';
import { getSelectedTableView } from 'owa-mail-list-store';

export default function isGroupTableSelected(): boolean {
    const selectedTable = getSelectedTableView();
    return selectedTable && isGroupTableQuery(selectedTable.tableQuery);
}
